//
//
//
//
//
//

export default {
    data() {
        return {
            payTypeAction: false,
            payTypeMenus: [{
                label: '微信支付',
                type: 6
            },{
                label: '支付宝支付',
                type: 8
            }],
            payData: null
        }
    },
    methods: {
        showPayAction(payData) {
            this.payData = payData;
            if(this.$isWeixin()) {
                var payWay = this.$isWeixinApp() ? 9 : 7; //9 小程序内支付，7 微信网页内支付
                this.payOrder(payWay);
            } else {
                this.payTypeAction = true;
            }
        },
        checkPayType(menuKey, menuItem) {
            if(menuKey == 'cancel') {
                
            } else {
                this.payOrder(menuItem.type);
            }
        },
        payOrder(payWay) {
            let that = this; that.$vux.loading.show();
            var goodsOrderId = that.payData.goodsOrderId;
            var redirect_url = sessionStorage.domainURL + '/LonBonStore/#/orderDetail?readyPayOrderId='+goodsOrderId+'&redirect=true';
            // var redirect_url = sessionStorage.domainURL + '/LonBonStore/#/orderDetail?token='+sessionStorage.token+'&readyPayOrderId='+goodsOrderId+'&redirect=true';
            var payOrder = {
                description: '订单支付',
                payWay: payWay,
                wapUrl: sessionStorage.domainURL,
                wapName: '来邦移动商城',
                returnUrl: redirect_url,
                ...that.payData
            }
            var data = {
                payOrder: JSON.stringify(payOrder)
            }
            console.log(data)
            that.$axios.post('/api/v1.0/lonbonShop/pay', that.qs.stringify(data)).then(function (response) {
                that.$vux.loading.hide();
                if(response.status == 200) {
                    if(payWay == 6) { //微信外支付
                        var weChatOrder = response.body.weChatOrder;
                        var url = weChatOrder.mwebUrl + '&redirect_url=' + encodeURIComponent(redirect_url);
                        window.location.href = url;
                    } else if (payWay == 7 || payWay == 9) { //微信内支付
                        that.inWxPay(response.body.weChatOrder, payWay, encodeURIComponent(redirect_url));
                    } else if (payWay == 8) { //支付宝外支付
                        that.outAliPay(response.body.form);
                    }
                    if(payWay != 7) {
                        setTimeout(() => {
                            that.$emit('showIsPay'); 
                        }, 1500);
                    }
                }
            }).catch(function () {
                that.$vux.loading.hide();
            })
        },
        //微信内支付
        inWxPay(data, payWay, redirectUrl){
            let that = this;
            let wxForm = {
                "appId": data.appId,
                "timeStamp": data.timeStamp,
                "nonceStr": data.nonceStr,    
                "package": data.package,     
                "signType": data.signType,   
                "paySign": data.paySign
            }
            console.log(wxForm)
            if(payWay == 9) {//小程序支付
                console.log("微信小程序支付")
                wxForm.package = wxForm.package.replace('=','%3D');
                that.$wechat.miniProgram.navigateTo({url: '/pages/pay/pay?wxForm=' + JSON.stringify(wxForm) + '&redirectUrl=' + redirectUrl})
            } else { //微信网页支付
                console.log("微信网页支付")
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', wxForm,
                    function(res){
                        console.log(res)
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            that.$vux.toast.show({
                                text: '支付成功',
                                type: 'success'
                            })
                        } else {
                            that.$vux.toast.show({
                                text: '支付失败',
                                type: 'cancel'
                            })
                        }
                        that.$emit("loadDetail");
                    }
                ); 
            }
        },
        //支付宝支付
        outAliPay(data) {
            let divForm = document.getElementsByTagName('divform')
            if (divForm.length) {
                document.body.removeChild(divForm[0])
            }
            const div = document.createElement('divform');
            div.innerHTML = data;
            document.body.appendChild(div);
            document.forms[0].submit();
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/buycar/goPay.vue